import { Link } from "@reach/router";
import Reviews from "components/homepage/reviews";
import ServicesGrid from "components/homepage/servicesGrid";
import TranslateAgency from "components/homepage/translateAgency";
import TranslationServices from "components/homepage/translationServices";
import WhatChooseUs from "components/homepage/whyChooseUs";
import LocationBanner from "components/locationBanner";
import CommonUse from "components/LocationReusableComp/commonuse";
import SpeceficTranslation from "components/LocationReusableComp/speceficTranslation";
import React from "react";
import AcadmicInstruction from "../AcadmicInstruction";
import Benifits from "../Benifits";
import LocalizationMidText from "../localizationMidText";
import TechnicalDocument from "../technicalDocument";
import WhatsAppComp from "../whatsappComp";
import BusinessCases from "./BusinessCases";
import { BusinessConfigData, BusinessData } from "./config";

function BusinessTranslation() {
  return (
    <>
      <LocationBanner
        backgroundCol="bg-midBlue"
        title="Business translation services"
        content="From aiding communication to boosting sales, business translation helps global companies to maximize their potential in new markets. At Tomedes, we provide the full suite of language services necessary to drive your growth, with 120 languages and 950+ language pairs."
        formOrangeHead="Get in touch "
        formWhiteHead="with our translation company"
      />
      {/* <AcadmicInstruction
        BackgroundCol="bg-darkBlue"
        colorHead="Trusted"
        head="Business Translation Services"
        secondHead="by Global Enterprises"
        content="Tomedes is trusted by Fortune 500 companies worldwide as well as global small and medium businesses. Join our 95,000+ satisfied customers today."
      /> */}
      <TranslateAgency
        head="Business Translation Services"
        colorHead="Trusted"
        lastHeadText="by Global Enterprises"
        content="Tomedes is trusted by Fortune 500 companies worldwide as well as global small and medium businesses. Join our 95,000+ satisfied customers today."
      />
      <LocalizationMidText
        backgroundCol="bg-midBlue"
        orangeMidText="business"
        content="translation services help all business owners achieve their global objectives. We provide scalable and guaranteed business solutions that are delivered on time by our team of experts."
      />
      <Benifits
        BackgroundCol="bg-darkBlue"
        firsttitle=" "
        secondTitle="Features"
        thirdTitle=" "
        BefitisData={BusinessData}
      />
      <WhatsAppComp
        backgroundCol="bg-midBlue"
        fHead="Professional"
        sHead=""
        fHeadCol="text-orange"
        secondHead=" Business Translation Services"
        thirdHead="When You Want It"
        content="Tired of bureaucratic processes and long emails? You can reach us through the following
        channels and we'll discuss whatever you need anytime, 24/7."
        whatsUp
      />
      <CommonUse
        backgroundCol="bg-darkBlue"
        title="All-Inclusive Translation Services for Businesses"
        para="Tomedes provides a wide range of all-inclusive translation services for your firm. This ranges from a wide
        variety of services, including:"
        data={BusinessConfigData}
      />
      <TechnicalDocument
        backgroundCol="bg-midBlue"
        firstHead="Let's talk"
        colHead="business"
        headColor="text-orange"
        secondHead=" "
        para="Are you ready to talk business with Tomedes? If you need help closing a client but can't speak their language, or
      your firm is merging with a local company in another country, Tomedes is here for you. Send your email using
      the field below and we'll be in touch within 30 minutes."
      />
      <SpeceficTranslation
        FirstOrange="Communicate"
        SecondWhite="your business in over 120 languages and 950+ language pairs"
        headColor="text-orange"
        Content="If you want to communicate externally as a B2C company or business-to-business as a B2C or simply want to improve your internal and external communication in different languages, Tomedes can help. We provide translation, localization, and interpretation business services in 120 languages and 950+ language pairs, such as French, Japanese, Chinese (Simplified and Traditional), Arabic, and Spanish. Here's a list of our languages to learn more about what we offer, including rare and hard-to-find languages."
        backgroundCol="bg-bussiness-img"
      />
      <ServicesGrid
        backgroundCol="bg-midBlue"
        heading="Business Document Translation for Every Industry "
        details="We provide business document translation services for every industry imaginable, and have proven results with 95,000+ satisfied clients. Our work in some industries include the following:"
        contactUs={
          <Link
            to="/contactus.php"
            className=" bg-orange text-white rounded-3xl uppercase py-2 px-8 mt-6 inline-block  mlap:mb-10"
          >
            contact us
          </Link>
        }
      />
      <BusinessCases
        backgroundCol="bg-darkBlue"
        firstTitle="Common"
        midTitle="Uses"
        midCol="text-lightBlue"
        secondTitle="for Business Translations"
        para=" "
      />
      <WhatChooseUs backgroundCol="bg-midBlue" />
      <Reviews backgroundCol="bg-darkBlue" />
      <TranslationServices backgroundCol="bg-midBlue" />
    </>
  );
}

export default BusinessTranslation;
